/**
 * @graph-stack product-innovation-lab
 * @graph-domain UX
 * @graph-business マイページのバグ評価 i-point と スキル評価平均スコアの色を CSS class として返すヘルパー
 * @graph-connects none
 */

/** バグ評価 i-point の色（8+:赤太字 / 5+:黄 / それ以下:緑） @graph-connects none */
export function getBugIPointColor(score: number): string {
  if (score >= 8) return 'text-red-600 font-bold';
  if (score >= 5) return 'text-yellow-600 font-semibold';
  return 'text-green-600';
}

/** スキル評価平均スコアの色（7+:緑 / 5+:青 / 3+:黄 / それ以下:赤 / null:muted） @graph-connects none */
export function getSkillEvalScoreColor(score: number | null): string {
  if (score == null) return 'text-[var(--color-text-muted)]';
  if (score >= 7) return 'text-[var(--color-success)]';
  if (score >= 5) return 'text-[var(--color-info)]';
  if (score >= 3) return 'text-[var(--color-warning)]';
  return 'text-[var(--color-error)]';
}
